import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setupNavigation } from "../../../redux/actions/navItemsActions"
import { loadUserProfile } from "../../../redux/actions/userActions";
import Spinner from "../../common/Spinner";
import { toast } from "react-toastify";
import "../profile/ProfilePage.css";
import EditProfileBanner from "./EditProfileBanner";
import GarminConnectAuthControl from "../../Integrations/Garmin/GarminConnectAuthControl";

function GarminConnectSettingsPage({
    user,
    auth,
    settings,
    setupNavigation,
    loadUserProfile,
    history,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);
    const [settingDetails, setSettingDetails] = useState({
        firstName: "",
        surname: "",
        email: "",
        location: "",
        preferredMeasurementUnits: "0",
        subscribedMarketingNotification: false,
        subscribedRideBlogsNotification: false,
        approveFollowers: false,
        avatar: { src: "", preview: "" }
    });


    const navigationItems =
    {
        sections: [
            {
                name: 'Settings',
                showTitle: true,
                items: [
                    {
                        path: '/user/settings/general',
                        text: 'General Settings',
                        icon: 'fas fa-tasks'
                    },
                    {
                        path: '/user/settings/site',
                        text: 'Site Settings',
                        icon: 'fas fa-cogs'
                    },
                    {
                        path: '/user/settings/security',
                        text: 'Security',
                        icon: 'fas fa-key'
                    },
                    {
                        path: '/user/settings/garmin',
                        text: 'Garmin Connect',
                        icon: 'fas fa-mobile-android-alt'
                    },
                    {
                        path: '/user/settings/closeaccount',
                        text: 'Close Account',
                        icon: 'fas fa-user-times'
                    }
                ]
            }
        ]
    };

    useEffect(() => {
        document.title = "Garmin Connect Settings | JustGoRide";
        setupNavigation(navigationItems);
        if (!user || !user.id) {
            history.push("/login");
        }
        if (!settings.email) {
            setProcessing(true);
            loadUserProfile(user.id)
                .then((s) => {
                    s.avatarDetails = { src: "", preview: s.avatar }
                    setSettingDetails(s);
                    setProcessing(false);
                })
        }
        else {
            settings.avatarDetails = { src: "", preview: settings.avatar }
            setSettingDetails(settings);
            setProcessing(false);
        }
    }, []);

    

    return (
        processing ?
            <Spinner /> :
            <div>
                <EditProfileBanner title="Garmin Connect Settings" />
                <div className="settings-container row justify-content-md-center pb-5">
                    <GarminConnectAuthControl />
                </div>
            </div>

    );

}



GarminConnectSettingsPage.propTypes =
{
    setupNavigation: PropTypes.func.isRequired,
    loadUserProfile: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    errorMessage: PropTypes.string
}


function mapStateToProps(state) {
    return {
        user: state.user,
        settings: state.settings,
        auth: state.auth
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadUserProfile
}

export default connect(mapStateToProps, mapDispatchToProps)(GarminConnectSettingsPage);


// WEBPACK FOOTER //
// ./src/components/user/settings/GarminConnectSettingsPage.js